import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import components from './components';
import { getBotAuthMiddleware, setAuthenticatedBotCacheHeader } from './utils';
async function load(app, options = {}) {
  const {
    authenticatedBotHeaders = [],
    botCacheControlHeader = process.env.BLAZE_BOT_CACHE_CONTROL_HEADER
  } = options;
  if (authenticatedBotHeaders.length) {
    app.addMiddleware(getBotAuthMiddleware(app, authenticatedBotHeaders));
    if (botCacheControlHeader) {
      setAuthenticatedBotCacheHeader(app, authenticatedBotHeaders, botCacheControlHeader);
    }
  }
  app.events.once('load:custom:page-builder:component', addComponent => {
    Object.entries(components).forEach(([key, component]) => addComponent({
      key,
      component
    }));
  });
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
export default load;
//# sourceMappingURL=index.js.map